import { HashAnchor } from 'components/HashAnchor';
import CustomSelect from 'components/shared/CustomSelect';
import FormGroup from 'components/shared/FormGroup';
import { Controller, useFormContext } from 'react-hook-form';
import { FormCustomSelectProps } from './FormCustomSelect.types';

export const FormCustomSelect: React.FC<FormCustomSelectProps> = ({
  name,
  options,
  formGroup = {},
  input = {},
  children
}) => {
  const {
    control,
    formState: { errors }
  } = useFormContext();

  const onChangeHandler =
    input.onChange ||
    (() => {
      // NOOP
    });

  return (
    <FormGroup
      error={errors?.[name]?.message?.toString()}
      forId={name}
      {...formGroup}
    >
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <>
            <HashAnchor name={`anchor_${name}`} />
            <CustomSelect
              id={name}
              options={options || []}
              {...input}
              {...field}
              onChange={(e) => {
                field.onChange(e);
                onChangeHandler(e);
              }}
            />
          </>
        )}
      />

      {children}
    </FormGroup>
  );
};
